import React from 'react'
import styled from 'styled-components'
import { desktopSize } from 'theme'

const CouponFooter = () => {
  const year = new Date().getFullYear()
  return (
    <FooterWapper>
      <FooterText>香港01有限公司版權所有@{year}</FooterText>
    </FooterWapper>
  )
}

const FooterWapper = styled.div`
  background: ${(p) => p.theme.color.white};
  height: 64px;
  width: 100%;
  padding: 0 24px;
  line-height: 64px;
  text-align: center;
  box-sizing: border-box;
  @media ${desktopSize} {
    text-align: right;
    border-top: 0;
  }
`
const FooterText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(p) => p.theme.color.grey400};
`
export default CouponFooter
